import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { BrandHealthAdapter } from '@/adapters/brand-health.adapter';
import type { ApiResponse } from '@/types';
import type {
  BrandHealthDateRange,
  BrandHealthFiltersResponseDto,
  BrandHealthOverviewResponseDto,
  BrandHealthQuery,
} from '@/types/brandHealth';

function params(query: BrandHealthQuery): URLSearchParams {
  const result = new URLSearchParams({ startDate: query.startDate, endDate: query.endDate });
  // Absent rather than empty when unscoped: the backend reads a missing bu_id as
  // account-wide, and `bu_id=` would work by accident rather than by contract.
  if (query.buId) result.append('bu_id', query.buId);
  query.channels?.forEach((channel) => result.append('channel', channel));
  query.categories?.forEach((category) => result.append('category', category));
  return result;
}

export const brandHealthService = {
  async getOverview(query: BrandHealthQuery) {
    const response = await api.get<ApiResponse<BrandHealthOverviewResponseDto>>(
      API_ENDPOINTS.SENTINEL.BRAND_HEALTH.OVERVIEW,
      { params: params(query) },
    );
    return BrandHealthAdapter.fromOverviewApi(response.data.data);
  },

  async getFilters(query: BrandHealthDateRange) {
    const response = await api.get<ApiResponse<BrandHealthFiltersResponseDto>>(
      API_ENDPOINTS.SENTINEL.BRAND_HEALTH.FILTERS,
      { params: params(query) },
    );
    return BrandHealthAdapter.fromFiltersApi(response.data.data);
  },
};
